export default "__VITE_ASSET__9ID0yul5__"